import { showLoading, hideLoading } from 'react-redux-loading-bar';
import get from 'lodash/get';

import { shouldFetchItems } from './selectors';
import HttpV2 from '../../httpv2';
import * as types from './constants';

const ITEMS_PER_PAGE = 50;

const fetchV2Items = (url, skip = 0) => dispatch =>
  HttpV2.get(url, { limit: ITEMS_PER_PAGE, skip }).then((response) => {
    const items = get(response, 'rows', []);
    dispatch({
      type: types.FETCH_ITEMS,
      payload: items,
    });
    return (items.length === ITEMS_PER_PAGE);
  });

const fetchAllItems = endpoint => async (dispatch, getState) => {
  if (!shouldFetchItems(getState())) return;
  dispatch({ type: types.CLEAR_ITEMS });
  dispatch(showLoading());
  let skip = 0;
  let fetching = true;
  while (fetching) {
    fetching = await dispatch(fetchV2Items(endpoint, skip)); // eslint-disable-line
    skip += ITEMS_PER_PAGE;
  }
  dispatch(hideLoading());
};

export const fetchBrandItems = brandId => fetchAllItems(`/brand/${brandId}/product-category`);

const fetchItem = url => dispatch =>
  HttpV2.get(url).then(response =>
    dispatch({
      type: types.FETCH_ITEM,
      payload: response,
    })
  );
export const fetchBrandItem = (brandId, id) => fetchItem(`/brand/${brandId}/product-category/${id}`);

const addItem = (url, data) => dispatch =>
  HttpV2.post(url, data).then(response =>
    dispatch({
      type: types.ADD_ITEM,
      payload: response,
    })
  );
export const addBrandItem = (brandId, data) => addItem(`/brand/${brandId}/product-category`, data);

const updateItem = (url, data) => dispatch =>
  HttpV2.put(url, data).then(response =>
    dispatch({
      type: types.UPDATE_ITEM,
      payload: response,
    })
  );
export const updateBrandItem =
  (brandId, id, data) => updateItem(`/brand/${brandId}/product-category/${id}`, data);

const deleteItem = (url, id) => dispatch =>
  HttpV2.delete(url).then(() =>
    dispatch({
      type: types.DELETE_ITEM,
      payload: id,
    })
  );
export const deleteBrandItem = (brandId, id) => deleteItem(`/brand/${brandId}/product-category/${id}`, id);
